export default __webpack_public_path__ + "static/media/logo-mobile.c17a467e.svg";